import BYOButton from './BYOButton';

export default BYOButton;



// WEBPACK FOOTER //
// ./src/components/BYOButton/index.js